'use client';
import Link from 'next/link';
import React from 'react';
import { FaXmark } from 'react-icons/fa6';
import { useAppDispatch } from '@/lib/redux/hooks';
import { updateQuantity, removeItem } from '@/lib/redux/features/cart';
import { usePathname } from 'next/navigation';
interface CartItem {
  id: string;
  title?: string;
  imgSrc?: string;
  price: number;
  rating?: number;
  reviews?: number;
  quantity: number;
  categories?: string;
}
const CartTableRow = ({ product }: { product: CartItem }) => {
  const dispatch = useAppDispatch();
  const pathName = usePathname();
  const decreaseQuantity = (id: string) => {
    if (product.quantity > 1) {
      dispatch(updateQuantity({ id, quantity: product.quantity - 1 }));
    }
  };

  const increaseQuantity = (id: string) => {
    dispatch(updateQuantity({ id, quantity: product.quantity + 1 }));
  };

  const removeProduct = (id: string) => {
    dispatch(removeItem(id));
  };

  return (
    <tr>
      <td className="cart__item">
        <div className="cart__item-thumb">
          <Link href="#">
            <img src={product.imgSrc} alt={product.title} />
          </Link>
        </div>
        <div className="cart__item-content">
          <h4>
            <Link href="#">{product.title}</Link>
          </h4>
        </div>
      </td>
      <td className="align-middle">
        ${product.price ? Number(product.price).toFixed(2) : '0.00'}
      </td>
      <td className="cart__quantity align-middle">
        <div className="quantity-button quantity-button--style2">
          <button
            className="quantity-button__control quantity-button__control--decrease"
            onClick={() => decreaseQuantity(product.id)}
          >
            -
          </button>
          <span className="quantity-button__display">{product.quantity}</span>
          <button
            className="quantity-button__control quantity-button__control--increase"
            onClick={() => increaseQuantity(product.id)}
          >
            +
          </button>
        </div>
      </td>
      <td className="align-middle">
        ${(Number(product.price) * Number(product.quantity)).toFixed(2)}
      </td>
      {pathName === '/wishlist' && (
        <td className="align-middle">
          <a className="trk-btn trk-btn--outline ">Add to cart</a>
        </td>
      )}
      <td className="align-middle">
        <div className="close-btn">
          <span
            style={{ cursor: 'pointer' }}
            onClick={() => removeProduct(product.id)}
          >
            <FaXmark />
          </span>
        </div>
      </td>
    </tr>
  );
};

export default CartTableRow;
